import styled from 'styled-components';
export const StyledCalendarContainer = styled.div `
  display: flex;
  justify-content: center;
  padding: var(${(props) => props.theme.responsive.spacing.m});

  overflow-y: auto;
`;
//# sourceMappingURL=DatePicker.styles.js.map